import { render, staticRenderFns } from "./annexlist.vue?vue&type=template&id=f196116e"
import script from "./annexlist.vue?vue&type=script&lang=js"
export * from "./annexlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports